import * as THREE from 'three';
const TWEEN = require('@tweenjs/tween.js');
export default {
  data() {
    return {
      tweenShow: {},
      tweenHide: {},
      highlightingRunning: {}
    }
  },
  computed: {
    rayTracerDisabled() {
      return this.$store.state.utils.trayDisabled.swatches || this.$store.state.utils.trayDisabled.geostates;
    },
    useEcomDataLayerFormat() {
      return this.$store.getters['utils/useEcomDataLayerFormat'];
    },
    isApparel() {
      return this.$store.getters['utils/isApparelEnabled'];
    },
  },
  methods: {
    rayTraceComponent(e) {
      if (this.rayTracerDisabled) {
        return;
      }

      let componentName;
      const raycaster = new THREE.Raycaster();
      const mouse = new THREE.Vector2();

      mouse.x = e.clientX / window.innerWidth * 2 - 1;
      mouse.y = 2 * -(this.getHeaderOffset(e) / this.calculateRendererHeight()) + 1;

      raycaster.setFromCamera(mouse, this.camera);
      const intersections = raycaster.intersectObjects(this.$model3D.sceneHelpers.getScene().children, !0);

      if (intersections.length > 0) {
        this.rotateStop(false);

        if (this.useEcomDataLayerFormat) {
          this.$customizerDataLayer.logAnalyticsEvent({
            type: this.$customizerDataLayer.types.customizerRotateModel
          });
        }

        // Set component Name if it exist into the pdm component order property
        let groupComp = [];
        const configurableComp = Object.keys(this.pdm.components).filter(key => this.pdm.components[key].configurable );

        for (let componentName of configurableComp) {
        	const compConfigGroup = this.pdm.components[componentName].component_configuration_group;
        	if (compConfigGroup) {
        		groupComp.push(compConfigGroup)
          }
        }

        const components = intersections.filter(intersection => configurableComp.concat(groupComp.flat()).includes(intersection.object.name));

        if(components.length == 0) return;

        componentName = components[0].object.name;

        if (this.pdm.components[componentName]) {
          const parentComponent = this.$store.getters["componentConfigGroup/getComponentGroupedParent"](componentName);
          if (parentComponent) {
            componentName = parentComponent;
          }

          if (this.pdm.components[componentName].configurable && (this.$store.state.geometryUpdates.disabledComponents && !this.$store.state.geometryUpdates.disabledComponents[componentName])) {
            if (!this.$model3D.sceneHelpers.getSceneObjectByName({ objectName: componentName })) {
              console.log('Component was not set up correctly: ' + componentName);
              return;
            }

            if (this.useEcomDataLayerFormat) {
              this.$customizerDataLayer.logAnalyticsEvent({ type: this.$customizerDataLayer.types.selectComponentVisual, componentName });
            }
            // componentName, dataLayerType, setRotate, componentDisplayName, componentHighlighting, openGraphicEditor, updateStandardNavigation
            if (this.isApparel) this.$eventBus.$emit("select-component", componentName, null, false, "", true, true, true);
            else this.$eventBus.$emit("select-component", componentName, null, false);
          }
        }
      }
    },
    getHeaderOffset(e) {
      // offsetY gives the most accurate Y position on canvas but only exists for click events
      if (e.offsetY){
        return e.offsetY;
      }
    },
    calculateRendererHeight() {
      const scene = document.getElementById("scene");
      return scene.getElementsByTagName("canvas")[0].getBoundingClientRect().height;
    },
    componentHighlighting(componentName) {
      if (this.highlightingRunning[componentName] || !this.$model3D.sceneHelpers.getScene()) {
        return;
      }

      const sceneComponent = this.$model3D.sceneHelpers.getSceneObjectByName({ objectName: componentName });
      const highLightedObjects = [];
      const stitchComponents = [];

      if (sceneComponent) {
        const parentComponent = this.$store.getters["componentConfigGroup/getComponentGroupedParent"](componentName);
        this.highlightingRunning[componentName] = true;
        if (parentComponent) {
          const componentGroup = this.$store.state.componentConfigGroup.componentsParentChildConfiguration[parentComponent];

          for (const objectName of componentGroup) {
            if (this.$model3D.sceneHelpers.getSceneObjectByName({ objectName })) {
              highLightedObjects.push(this.$model3D.sceneHelpers.getSceneObjectByName({ objectName }));

              if (this.pdm.components[objectName].stitch_component) {
                stitchComponents.push(objectName);
              }
            }
          }
        } else {
          highLightedObjects.push(sceneComponent);
        }
      }

      // Animate highlighting
      if (highLightedObjects && highLightedObjects.length !== 0) {
        highLightedObjects.forEach(highLightedObject => {
          const { name, material } = highLightedObject;

          if (material.shader) {
            const highlightAlpha = material.shader.uniforms && material.shader.uniforms.highLightAlpha;
            const notStitchComponent = !stitchComponents.includes(name);
            let showConfig = null;
            let hideConfig = null;
            let colorToUse = null;
            let lastAlpha = 0.0;

            if (this.tweenShow[name]) {
              lastAlpha = this.$model3D.sceneHelpers.getUniform(material, "highLightAlpha").value;
              this.tweenShow[name].stop();
              this.tweenHide[name].stop();
            }

            highLightedObject.material.shader.uniforms.highLightAlpha.value = lastAlpha;

            if (notStitchComponent) {
              highLightedObject.material.shader.uniforms.useHighLight.value = 1
            }

            if (highlightAlpha && notStitchComponent) {
              showConfig = { value: 0.7 };
              hideConfig = { value: 0.0 };
              colorToUse = highlightAlpha;
            } else {
              showConfig = { ...material.uniforms.highLightColor.value };
              hideConfig = { ...material.color.clone() };
              colorToUse = material.color;
            }

            this.tweenShow[name] = new TWEEN.default.Tween(colorToUse)
              .to(showConfig, 650)
              .delay(200)
              .easing(TWEEN.default.Easing.Quadratic.Out)
              .start();
            this.tweenHide[name] = new TWEEN.default.Tween(colorToUse)
              .to(hideConfig, 400)
              .easing(TWEEN.default.Easing.Quadratic.In);
            this.tweenShow[name].chain(this.tweenHide[name]);
            this.tweenHide[name].onComplete(() => {
              if (highLightedObject.material.shader) {
                highLightedObject.material.shader.uniforms.useHighLight.value = 0;
                highLightedObject.material.shader.uniforms.highLightAlpha.value = 0.0;
              }
              delete this.tweenShow[name];
              delete this.tweenHide[name];
              this.highlightingRunning[componentName] = false;
            });
          }
        });
      }
    },
    /*
    * @function  setUniform
    * @param {Object} material - THREE.<Material>
    * @param {String} uniformName
    * @param {Object} value
    * Update uniforms for material if it was initialize before
    */
    setUniform({material, uniformName, value}) {
      if (material && material.uniforms) {
        return this.$model3D.customShaderMaterial.MaterialBuilderFactory.setUniform({material: material, uniformName: uniformName, value: value});
      } else {
        return material;
      }
    }
  }
};
